import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"display":"flex"}
}
const _hoisted_2 = { key: 1 }


import { DBFile } from "@/classes";
import FileUpload from "@/components/base/inputs/FileUpload.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FileField',
  props: /*#__PURE__*/_mergeModels({
  disabled: {
    type: Boolean,
    default: false,
  },
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {



const model = _useModel<DBFile | null>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (model.value)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createVNode(_component_v_text_field, _mergeProps({
          value: model.value.filename
        }, _ctx.$attrs), {
          prepend: _withCtx(() => [
            _createVNode(_component_v_btn, {
              icon: "mdi-download",
              variant: "plain",
              density: "compact",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (model.value.download()))
            })
          ]),
          append: _withCtx(() => [
            _createVNode(_component_v_btn, {
              disabled: __props.disabled,
              icon: "mdi-close",
              variant: "plain",
              density: "compact",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (model.value = null))
            }, null, 8, ["disabled"])
          ]),
          _: 1
        }, 16, ["value"])
      ]))
    : (_openBlock(), _createElementBlock("span", _hoisted_2, [
        _createVNode(FileUpload, _mergeProps(_ctx.$attrs, {
          onUpload: _cache[2] || (_cache[2] = ($event: any) => (model.value = $event))
        }), null, 16)
      ]))
}
}

})